import {useEffect, useState} from 'react'

import {List, Map} from 'immutable'
import {useForm, Controller} from 'react-hook-form'
import PropTypes from 'prop-types'

import {Button, Cancel} from '../../blocks/Buttons'
import ButtonGroup from '../../../../../shared_components/core/buttons/ButtonGroup'
import {humanizedFullName} from '../../../../../lib/nameTools'
import {existingPermissionOptions, defaultSpecificItemDeputiesPermissionValues, showsSuggestedDeputies, suggestedDeputiesEverplanId} from '../../../../../lib/deputyPermissionTools'
import PermissionSelect from './shared_components/PermissionSelect'
import SuggestedDeputies from '../../corp_max_deputies/SuggestedDeputies'
import './manageExistingPermissions.scss'

const ManageExistingPermissions = props => {
  const {control, formState: {isDirty}, handleSubmit} = useForm({
    defaultValues: defaultSpecificItemDeputiesPermissionValues({deputiesWithPermission: props.deputiesWithPermission})
  })
  const [isSaveButtonDisabled, setIsSaveButtonDisabled] = useState(true)

  useEffect(() => {
    if (isDirty)
      setIsSaveButtonDisabled(false)
    else
      setIsSaveButtonDisabled(true)
  }, [isDirty])

  return (
    <form className='manage-existing-permissions'>
      {
        showsSuggestedDeputies(props) &&
        <SuggestedDeputies
          deputies={props.deputies}
          everplanId={suggestedDeputiesEverplanId(props)}
          firstGroupId={props.firstGroupId}
          itemResponses={props.itemResponses}
          onAddDeputy={props.addNewDeputyLink}
          onShareWithDeputy={props.setDeputyToShareWith}
          vaultExtension={props.vaultExtension}
          context={props.context}
        />
      }
      <div className='shared-with'>Currently shared with</div>
      <div className='existing-permissions'>
        {
          props.deputiesWithPermission.map(deputy => (
            <div className='existing-permission-container' key={deputy.get('ownership-id')}>
              <div className='name'>{humanizedFullName(deputy.get('ownable'))}</div>
              <Controller
                name={deputy.get('ownership-id').toString()}
                control={control}
                render={({field}) => (
                  <PermissionSelect
                    {...field}
                    classNamePrefix='existing-permission-select'
                    options={existingPermissionOptions}
                  />
                )}
              />
            </div>
          ))
        }
      </div>
      <a className='add-deputy-link' onClick={() => props.addNewDeputyLink()}>
        Add a new Deputy
      </a>
      <ButtonGroup>
        <Cancel onClick={props.toggleModal} disabled={props.processing}>Cancel</Cancel>
        <Button disabled={isSaveButtonDisabled} onClick={handleSubmit(props.onSubmit)} processing={props.processing}>Save</Button>
      </ButtonGroup>
    </form>
  )
}

ManageExistingPermissions.propTypes = {
  addNewDeputyLink: PropTypes.func,
  context: PropTypes.string,
  deputies: PropTypes.instanceOf(List),
  deputiesWithPermission: PropTypes.instanceOf(List),
  firstGroupId: PropTypes.string,
  itemResponse: PropTypes.instanceOf(Map),
  itemResponses: PropTypes.instanceOf(List),
  onSubmit: PropTypes.func,
  processing: PropTypes.bool,
  toggleModal: PropTypes.func,
  vaultExtension: PropTypes.instanceOf(Map),
  setDeputyToShareWith: PropTypes.func
}

export default ManageExistingPermissions
